export { SmallSurveyCard } from './SmallSurveyCard';
